var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlaylistCheckIcon = function SvgPlaylistCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 4a1 1 0 0 0 0 2h15a1 1 0 1 0 0-2zM3 10.5a1 1 0 1 0 0 2h5.2a1 1 0 1 0 0-2zM2 18a1 1 0 0 1 1-1h5.2a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M23.727 10.563a1 1 0 1 0-1.653-1.126l-5.624 8.26-2.458-3.186a1 1 0 1 0-1.584 1.22l3.3 4.28a1 1 0 0 0 1.619-.048z"
  })));
};
export default SvgPlaylistCheckIcon;